import React from 'react'
import RetourCourt from '../components/RetourCourt'

function Algues() {
  return (
    <div>
        <div>
    <div style={{textAlign:"center", display:"flex", justifyContent: "center", alignItems: "center"}}>
    <p style={{fontSize:"50px", marginTop: "30px",width:"90%", fontFamily: "Risque, cursive", color: "red"}}>Bretagne. Algues vertes. Des promeneurs disparaissent…</p>
    </div>
    <div style={{textAlign:"center"}}> <RetourCourt /></div>
    </div>
    </div>
  )
}

export default Algues